module.exports = __webpack_public_path__ + "img/arrow_up_circle.5bc37ed5.svg";